export default __webpack_public_path__ + "static/drag-drop-8ce9b8c47720c64e640b9e5d9e66dc9e.mp4";